import ajax from '@/utils/ajax'

// 查询喊话示例
export const getDemoList = params => ajax.post('/shouts/getShoutExamples', params)

// 查询喊话权益剩余天数
export const getShoutLeftDays = params => ajax.post('/shouts/getShoutLeftDays', params)

// 新增喊话
export const addShouts = params => ajax.post('/shouts/createMasterShouts', params)

// 修改喊话
export const updateShouts = params => ajax.post('/shouts/updateShout', params)

// 获取喊话详情
export const shoutsDetail = params => ajax.post('/shouts/getActivityDetailById', params)

// 下线或取消
export const offlineShouts = params => ajax.post('/shouts/offlineShout', params)

/**
 * 
 * 天天特价活动
 */

// 下线或取消——送水活动
export const offlineSendWater = params => ajax.post('/market/offline', params)

// 详情——送水活动
export const getSendWaterDetail = params => ajax.post('/market/deliverWaterDetailByActivityId', params)
